











































































import Vue from "vue";
import { AxiosResponse } from "axios";
import { myAuctionApi } from "../utils/axios";
import Chatroom from "@/components/myauction/Chatroom.vue";

export default Vue.extend({
  name:"Myauction",
  components: {
    Chatroom,
  },
  data: () => ({
    sellPage: 1,
    buyPage: 1,
    open: false,
    chatInfo: {
      itemId: '0',
      myId: '0',
      me: '',
    },
    sellItemPage: 1,
    buyItemPage: 1,
    sellItems: [],
    buyItems: [],
  }),
  async created() {
    const uid = (this as any).$store.state.userModule.user.object.user.id;
    try {
      const { data } = await myAuctionApi.buyer(uid);
      console.log(data);
      this.buyItems = data.object;
    } catch(error) {
      console.log(error);
    }

    try {
      const { data } = await myAuctionApi.seller(uid);
      console.log(data);
      this.sellItems = data.object;
    } catch(error) {
      console.log(error);
    }
  },
  methods: {
    pay(index: number, itemId: number) {
      const data = {
        buyerId: (this.buyItems[index] as any).buyerId,
        itemId: itemId,
        name: (this.buyItems[index] as any).itemTitle,
        price: (this.buyItems[index] as any).finalPrice,
      }
      // console.log(data);
      myAuctionApi.pay(data).then((res: AxiosResponse) => {
        location.href = res.data.object.successUrl;
      });
    },
    async deliveryCompleted(userId: number, itemId: number) {
      try {
        const { data } = await myAuctionApi.sellerItem(userId, itemId);
        alert('배송완료!');
        window.location.reload();
      } catch(error) {
        console.log(error);
      }
    },
    async takeCompleted(userId: number, itemId: number) {
      try {
        const { data } = await myAuctionApi.buyerItem(userId, itemId);
        alert('수령확인!');
        window.location.reload();
      } catch(error) {
        console.log(error);
      }
    },
    async sellCompleted(index:number, userId: number, itemId: number) {
      try {
        const { data } = await myAuctionApi.finalItem(userId, itemId);
        alert((this.sellItems[index] as any).finalPrice + "원이 입금되었습니다.");
        window.location.reload();
      } catch(error) {
        console.log(error);
      }
    },
    openChat (itemId: string, me: string) {
      console.log('click openChat');
      this.open = true;
      this.chatInfo.itemId = itemId;
      this.chatInfo.myId = (this as any).$store.state.userModule.user.object.user.id;
      this.chatInfo.me = me;
    },
 
    sellRange(start: number, count: number) {
      let arr = [];
      let length = this.sellItems.length;
      
      if (length <= 0) return [];
      for (let i = 0; i < count; i++) { 
          arr[i] = start;
          start++;
          if (start >= length) break; 
      }
      return arr;
    },
    buyRange(start: number, count: number) {
      let arr = [];
      let length = this.buyItems.length;

      if (length <= 0) return [];
      for (let i = 0; i < count; i++) { 
          arr[i] = start;
          start++;
          if (start >= length) break; 
      }
      return arr;
    }
  },

})
